import React,{useState,useEffect, useContext} from "react";
import PaymentOnlineContextProvider, {
    PaymentOnlineContext,
    ACTIONS
  } from "../../context/PaymentOnlineContextProvider";
import {decode_utf8, getPathName} from "../../../../common/utils/utilsFunc";
import PaymentDetail from "../PaymentDetail";
import GetNumClient from "../GetNumClient";
import Loading from "../../../../common/components/Loading";

const ControllerPaymentOnline = ({props}) => {
    
    const [state, dispatch] = useContext(PaymentOnlineContext);

    const [numCli,setNumCli] = React.useState();
    const [valueRadio, setValueRadio] = React.useState("");
    const [responseDebtCc, setresponseDebtCc] = useState("");
    const [loading, setLoading] = React.useState(false);
    const [showErrorMsg, setShowErrorMsg] = React.useState(false);
    const [entities, setEntities] = React.useState();
    const [deudaActual, setDeudaActual] = React.useState();
    const [deudaVencida, setDeudaVencida] = React.useState();
    const [cleanCaptcha, setCleanCaptcha] = React.useState(false);

    const [showWebContent, setShowWebContent] = useState(false);
    const [webContentHtml, setWebContentHtml] = useState("");

    function auxSetNumCli(value) {
        setNumCli(value);
    }

    function nextStep() {
        if(numCli) {
            dispatch({
                payload: numCli,
                type: ACTIONS.SET_IDCTACTO,
            })      
        } else {
            props.setGlobalAlert("Debes ingresar el número de cliente.", "warning")
        }
    }

    const objGetNumCliComponent = {
        setNumCli:auxSetNumCli,
        numCli:numCli,
        nextStep:nextStep,
        can_enter_the_customer_number:props.can_enter_the_customer_number,
        msg_cant_enter_the_customer_numer:props.msg_cant_enter_the_customer_numer,
        setGlobalAlert:props.setGlobalAlert,
        state:state,
        api_key_recaptcha: props.api_key_recaptcha
    };

    const objPaymentDetailComponent = {
        numCli:numCli,
        showWebContent:showWebContent,
        webContentHtml:webContentHtml,
        setValueRadio:setValueRadio,
        valueRadio:valueRadio,
        api_key_recaptcha: props.api_key_recaptcha,
        titulo_detalle_de_cuenta: props.titulo_detalle_de_cuenta,
        subtitulo_1_detalle_de_cuenta: props.subtitulo_1_detalle_de_cuenta,
        subtitulo_2_detalle_de_cuenta: props.subtitulo_2_detalle_de_cuenta,
        subtitulo_3_detalle_de_cuenta: props.subtitulo_3_detalle_de_cuenta
    };

    useEffect(() => {
        let params = new URLSearchParams(document.location.search);
        setNumCli(params.get("cuentaContrato"));
    },[])

    useEffect(() => {
        if(state.idCtaCto) {
            dispatch({
                payload: ["OVIRTUAL", state.idCtaCto],
                type: ACTIONS.SET_JSON_DEBT,
            }) 
            dispatch({
                payload: "",
                type: ACTIONS.SET_IDCTACTO,
            });     
            setLoading(true)
        }
    },[state.idCtaCto]);

    useEffect(() => {
        
        if (state.webContentText !== "ERROR") {
            setShowWebContent(true);
            setWebContentHtml(state.webContentText);
        } else {
            setShowWebContent(false);
            setWebContentHtml("");
        }
        
        
    },[state.webContentText]);

    React.useEffect(() => {
        if(state.responseDebtCc){
            if(state.responseDebtCc.code === 0 || state.responseDebtCc.code) {
                if(state.responseDebtCc.code === 0 || state.responseDebtCc.code === 1) {
                    if(getPathName() === 'pago-en-linea'){
                        window.location.href = "detalle-de-cuenta?ctacto="+numCli;
                    } else {
                        setresponseDebtCc(state.responseDebtCc.edatosCupon)
                    }
                } else{
                    setLoading(false)
                    setresponseDebtCc(state.responseDebtCc)
                    props.setGlobalAlert(state.responseDebtCc?.mensaje ? state.responseDebtCc?.mensaje : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia")
                    dispatch({
                        payload: '',
                        type: ACTIONS.SET_JSON_DEBT,
                    })
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_IDCTACTO,
                    }); 

                }
            } else {
                setLoading(false)
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia")
                setresponseDebtCc(state.responseDebtCc.edatosCupon)
                dispatch({
                    payload: '',
                    type: ACTIONS.SET_JSON_DEBT,
                })
                dispatch({
                    payload: null,
                    type: ACTIONS.SET_IDCTACTO,
                }); 
            }
        } 

    }, [state.responseDebtCc])

    React.useEffect(() => {
        if(state.responseEntityPaid){
            if(state.responseEntityPaid?.code === 0) {
                setCleanCaptcha(true);
                setLoading(false)
                setEntities(state.responseEntityPaid?.entidadesPago)
                setDeudaActual(state.responseEntityPaid?.deudaActual)
                setDeudaVencida(state.responseEntityPaid?.deudaVencida)
            } else if(state.responseEntityPaid?.code !== 0 || state.responseEntityPaid?.status) {
                setLoading(false)
                setShowErrorMsg(true)
                props.setGlobalAlert(!state.responseEntityPaid?.message || state.responseEntityPaid?.status === 500  ? decode_utf8(props.text_fetch_error) : state.responseEntityPaid?.message, "warning", true, "Advertencia")
            }
        }
    }, [state.responseEntityPaid])

    
    return (
      <>
        {
        getPathName() === "pago-en-linea" && <GetNumClient props={objGetNumCliComponent} />
        }
        {
        (getPathName() === "detalle-de-cuenta" || getPathName() === "detalle-de-cuenta-priv") && <PaymentDetail props={{...objPaymentDetailComponent, ...props, state, dispatch, ACTIONS, responseDebtCc, entities, setLoading, loading, deudaActual, deudaVencida, cleanCaptcha, showErrorMsg}} />
        }
        {loading && <Loading />}
      </>
    );
};

const ControllerPaymentOnlineWithProvider = ({props}) => (
    <PaymentOnlineContextProvider>
      <ControllerPaymentOnline props={props} />
    </PaymentOnlineContextProvider>
  );
export default ControllerPaymentOnlineWithProvider;
  